<ng-container
    *ngIf="type === 'section'; then sectionTemplate; else productTemplate"
></ng-container>

<ng-template #sectionTemplate>
    <h5 class="section-header" *ngIf="!root">
        {{ filteredSection.name.displayName }}
    </h5>
    <ng-container
        *ngFor="let subsection of filteredSection.items; trackBy: trackSection"
    >
        <ng-container [ngSwitch]="getSectionType(subsection)">
            <div
                picker-selection-section
                *ngSwitchCase="'section'"
                [env]="env"
                [section]="subsection"
                [root]="false"
            ></div>
            <div
                picker-selection-product
                *ngSwitchCase="'product'"
                [env]="env"
                [section]="subsection"
                [root]="false"
            ></div>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #productTemplate>
    <div *ngFor="let inst of filteredSection.instances" class="title">
        {{ inst.name.displayName }}
        <a *ngIf="inst.canDelete" (click)="removeDivision(inst.division)"
            ><span class="zbd-action-icon icon-close-tag tracking-action"></span
        ></a>
        <span
            *ngIf="inst.isWaiting"
            class="zbd-action-icon icon-loop spinning tracking-action"
        ></span>
        <span *ngIf="inst.productVersion" class="product-version"
            >Versionsnummer: {{ inst.productVersion }}</span
        >
    </div>
</ng-template>
